import { AnyAction } from 'redux';
import { AxiosPromise, AxiosResponse } from 'axios';
import { ThunkAction } from 'redux-thunk';
import { Operation, ServerResponse } from 'data/types';
import { RootState } from 'data/root.reducers';
import { CollectionFunction } from 'data/collectionFunction/collectionFunction.types';

export const API_PATH_XTP_XDP_CONNECTION = '/lbcfci';
export const API_PATH_XTP_XDP_CONNECTION_CF = '/cfs';

export const GET_XTP_XDP_CONNECTION_LIST = 'GET_XTP_XDP_CONNECTION_LIST';
export const GET_XTP_XDP_CONNECTION_LIST_PENDING = 'GET_XTP_XDP_CONNECTION_LIST_PENDING';
export const GET_XTP_XDP_CONNECTION_LIST_FULFILLED = 'GET_XTP_XDP_CONNECTION_LIST_FULFILLED';
export const GET_XTP_XDP_CONNECTION_LIST_REJECTED = 'GET_XTP_XDP_CONNECTION_LIST_REJECTED';

export const GET_XTP_XDP_CONNECTION = 'GET_XTP_XDP_CONNECTION';
export const GET_XTP_XDP_CONNECTION_PENDING = 'GET_XTP_XDP_CONNECTION_PENDING';
export const GET_XTP_XDP_CONNECTION_FULFILLED = 'GET_XTP_XDP_CONNECTION_FULFILLED';
export const GET_XTP_XDP_CONNECTION_REJECTED = 'GET_XTP_XDP_CONNECTION_REJECTED';

export const CREATE_XTP_XDP_CONNECTION = 'CREATE_XTP_XDP_CONNECTION';
export const CREATE_XTP_XDP_CONNECTION_PENDING = 'CREATE_XTP_XDP_CONNECTION_PENDING';
export const CREATE_XTP_XDP_CONNECTION_FULFILLED = 'CREATE_XTP_XDP_CONNECTION_FULFILLED';
export const CREATE_XTP_XDP_CONNECTION_REJECTED = 'CREATE_XTP_XDP_CONNECTION_REJECTED';

export const UPDATE_XTP_XDP_CONNECTION = 'UPDATE_XTP_XDP_CONNECTION';
export const UPDATE_XTP_XDP_CONNECTION_PENDING = 'UPDATE_XTP_XDP_CONNECTION_PENDING';
export const UPDATE_XTP_XDP_CONNECTION_FULFILLED = 'UPDATE_XTP_XDP_CONNECTION_FULFILLED';
export const UPDATE_XTP_XDP_CONNECTION_REJECTED = 'UPDATE_XTP_XDP_CONNECTION_REJECTED';

export const DELETE_XTP_XDP_CONNECTION = 'DELETE_XTP_XDP_CONNECTION';
export const DELETE_XTP_XDP_CONNECTION_PENDING = 'DELETE_XTP_XDP_CONNECTION_PENDING';
export const DELETE_XTP_XDP_CONNECTION_FULFILLED = 'DELETE_XTP_XDP_CONNECTION_FULFILLED';
export const DELETE_XTP_XDP_CONNECTION_REJECTED = 'DELETE_XTP_XDP_CONNECTION_REJECTED';

export const GET_XTP_XDP_CONNECTION_PROTOCOL = 'GET_XTP_XDP_CONNECTION_PROTOCOL';
export const GET_XTP_XDP_CONNECTION_PROTOCOL_PENDING = 'GET_XTP_XDP_CONNECTION_PROTOCOL_PENDING';
export const GET_XTP_XDP_CONNECTION_PROTOCOL_FULFILLED = 'GET_XTP_XDP_CONNECTION_PROTOCOL_FULFILLED';
export const GET_XTP_XDP_CONNECTION_PROTOCOL_REJECTED = 'GET_XTP_XDP_CONNECTION_PROTOCOL_REJECTED';

export const CREATE_XTP_XDP_CONNECTION_PROTOCOL = 'CREATE_XTP_XDP_CONNECTION_PROTOCOL';
export const CREATE_XTP_XDP_CONNECTION_PROTOCOL_PENDING = 'CREATE_XTP_XDP_CONNECTION_PROTOCOL_PENDING';
export const CREATE_XTP_XDP_CONNECTION_PROTOCOL_FULFILLED = 'CREATE_XTP_XDP_CONNECTION_PROTOCOL_FULFILLED';
export const CREATE_XTP_XDP_CONNECTION_PROTOCOL_REJECTED = 'CREATE_XTP_XDP_CONNECTION_PROTOCOL_REJECTED';

export const DELETE_XTP_XDP_CONNECTION_PROTOCOL = 'DELETE_XTP_XDP_CONNECTION_PROTOCOL';
export const DELETE_XTP_XDP_CONNECTION_PROTOCOL_PENDING = 'DELETE_XTP_XDP_CONNECTION_PROTOCOL_PENDING';
export const DELETE_XTP_XDP_CONNECTION_PROTOCOL_FULFILLED = 'DELETE_XTP_XDP_CONNECTION_PROTOCOL_FULFILLED';
export const DELETE_XTP_XDP_CONNECTION_PROTOCOL_REJECTED = 'DELETE_XTP_XDP_CONNECTION_PROTOCOL_REJECTED';

export const UPDATE_XTP_XDP_CONNECTION_PROTOCOL = 'UPDATE_XTP_XDP_CONNECTION_PROTOCOL';
export const UPDATE_XTP_XDP_CONNECTION_PROTOCOL_PENDING = 'UPDATE_XTP_XDP_CONNECTION_PROTOCOL_PENDING';
export const UPDATE_XTP_XDP_CONNECTION_PROTOCOL_FULFILLED = 'UPDATE_XTP_XDP_CONNECTION_PROTOCOL_FULFILLED';
export const UPDATE_XTP_XDP_CONNECTION_PROTOCOL_REJECTED = 'UPDATE_XTP_XDP_CONNECTION_PROTOCOL_REJECTED';

export const XTP_XDP_CONNECTION_LOADING = 'XTP_XDP_CONNECTION_LOADING';
export const GO_TO_XTP_XDP_CONNECTION_CREATE = 'GO_TO_XTP_XDP_CONNECTION_CREATE';
export const GO_TO_XTP_XDP_CONNECTION_EDIT = 'GO_TO_XTP_XDP_CONNECTION_EDIT';
export const GO_TO_XTP_XDP_CONNECTION_VIEW = 'GO_TO_XTP_XDP_CONNECTION_VIEW';
export const GO_TO_XTP_XDP_CONNECTION_LIST = 'GO_TO_XTP_XDP_CONNECTION_LIST';
export const UPDATE_XTP_XDP_CONNECTION_ERRORS = 'UPDATE_XTP_XDP_CONNECTION_ERRORS';
export const SELECT_XTP_XDP_CONNECTION = 'SELECT_XTP_XDP_CONNECTION';

export enum XtpXdpConnectionMenuActionsType {
  Delete = 'delete',
  Edit = 'edit',
  View = 'view'
}

export enum XtpXdpConnectionPrivileges {
  View = 'dc_access',
  Edit = 'dc_access',
  Delete = 'dc_access',
}

export interface XtpXdpConnectionProtocol {
  id: string,
  cfid: string,
  ifid: string,
  destIp: string,
  lbId: string,
  netId: string,
  ipduId: string,
  transport: string,
  reqState: string,
  state: string,
  destPort: string,
  trclvl: string,
  type: string,
  name?: string,
  connectionId?: string,
  lbid?: string,
  ipduid?: string,
  hide?: boolean,
  operation?: Operation,
}

export interface XtpXdpConnection {
  id: string
  name: string
  type: string,
  cfid: string,
  ipduid: string,
  lbid: string,
  destIp: string,
  protocols: Partial<{[key: string]: XtpXdpConnectionProtocol}>
}

export const newXtp: XtpXdpConnection = {
  id: '',
  name: '',
  type: '',
  cfid: '',
  ipduid: '',
  destIp: '',
  lbid: '',
  protocols: {},
};

export const newXtpXdpConnectionProtocol: XtpXdpConnectionProtocol = {
  id: '',
  cfid: '',
  ifid: '',
  destIp: '',
  lbId: '',
  ipduId: '',
  reqState: 'ACTIVE',
  state: '',
  destPort: '',
  netId: 'xcp',
  transport: 'TCP',
  trclvl: '0',
  type: '',
  hide: false,
};

export interface XtpXdpConnectionUiState {
  isLoading: boolean,
  wasDataUpdatedWithErrors: boolean,
}

export interface XtpXdpConnectionState {
  entities: XtpXdpConnectionProtocol[],
  single: XtpXdpConnection | undefined,
  selected: XtpXdpConnectionProtocol[],
  ui: XtpXdpConnectionUiState,
  errors: { connection: string, protocols: string[] },
}

export interface GetXtpXdpConnectionActionThunkAction extends ThunkAction<void, RootState, void, AnyAction> {}

export interface GetXtpXdpConnectionAction extends AnyAction {
  type: typeof GET_XTP_XDP_CONNECTION_LIST
  payload: AxiosPromise<ServerResponse<XtpXdpConnection>>
}

export interface GetXtpXdpConnectionPendingAction extends AnyAction {
  type: typeof GET_XTP_XDP_CONNECTION_LIST_PENDING
  payload: AxiosResponse<ServerResponse<XtpXdpConnectionProtocol>>
}

export interface GetXtpXdpConnectionFulfilledAction extends AnyAction {
  type: typeof GET_XTP_XDP_CONNECTION_LIST_FULFILLED
  payload: AxiosResponse<ServerResponse<XtpXdpConnectionProtocol>>
}

export interface GetXtpXdpConnectionRejectedAction extends AnyAction {
  type: typeof GET_XTP_XDP_CONNECTION_LIST_REJECTED
  payload: AxiosResponse<ServerResponse<XtpXdpConnectionProtocol>>
}

export interface GetXtpXdpConnectionByIdActionThunkAction extends ThunkAction<void, RootState, void, AnyAction> {}

export interface GetXtpXdpConnectionByIdAction extends AnyAction {
  type: typeof GET_XTP_XDP_CONNECTION
  payload: AxiosPromise<ServerResponse<XtpXdpConnection>>
}

export interface GetXtpXdpConnectionByIdPendingAction extends AnyAction {
  type: typeof GET_XTP_XDP_CONNECTION_PENDING
  payload: AxiosResponse<ServerResponse<XtpXdpConnection>>
}
export interface GetXtpXdpConnectionByIdFulfilledAction extends AnyAction {
  type: typeof GET_XTP_XDP_CONNECTION_FULFILLED
  payload: AxiosResponse<ServerResponse<CollectionFunction>>
}

export interface GetXtpXdpConnectionByIdRejectedAction extends AnyAction {
  type: typeof GET_XTP_XDP_CONNECTION_REJECTED
  payload: AxiosResponse<ServerResponse<XtpXdpConnection>>
}

export interface CreateXtpXdpConnectionThunkAction extends ThunkAction<void, RootState, void, AnyAction> {}

export interface CreateXtpXdpConnectionAction extends AnyAction {
  type: typeof CREATE_XTP_XDP_CONNECTION
  payload: AxiosPromise<ServerResponse<XtpXdpConnection>>
}

export interface CreateXtpXdpConnectionPendingAction extends AnyAction {
  type: typeof CREATE_XTP_XDP_CONNECTION_PENDING
  payload: AxiosResponse<ServerResponse<XtpXdpConnection>>
}
export interface CreateXtpXdpConnectionFulfilledAction extends AnyAction {
  type: typeof CREATE_XTP_XDP_CONNECTION_FULFILLED
  payload: AxiosResponse<ServerResponse<XtpXdpConnection>>
}

export interface CreateXtpXdpConnectionRejectedAction extends AnyAction {
  type: typeof CREATE_XTP_XDP_CONNECTION_REJECTED
  payload: AxiosResponse<ServerResponse<XtpXdpConnection>>
}

export interface UpdateXtpXdpConnectionThunkAction extends ThunkAction<void, RootState, void, AnyAction> {}

export interface UpdateXtpXdpConnectionAction extends AnyAction {
  type: typeof UPDATE_XTP_XDP_CONNECTION
  payload: AxiosPromise<ServerResponse<XtpXdpConnection>>
}

export interface UpdateXtpXdpConnectionPendingAction extends AnyAction {
  type: typeof UPDATE_XTP_XDP_CONNECTION_PENDING
  payload: AxiosResponse<ServerResponse<XtpXdpConnection>>
}
export interface UpdateXtpXdpConnectionFulfilledAction extends AnyAction {
  type: typeof UPDATE_XTP_XDP_CONNECTION_FULFILLED
  payload: AxiosResponse<ServerResponse<XtpXdpConnection>>
}

export interface UpdateXtpXdpConnectionRejectedAction extends AnyAction {
  type: typeof UPDATE_XTP_XDP_CONNECTION_REJECTED
  payload: AxiosResponse<ServerResponse<XtpXdpConnection>>
}

export interface DeleteXtpXdpConnectionThunkAction extends ThunkAction<void, RootState, void, AnyAction> {}

export interface DeleteXtpXdpConnectionAction extends AnyAction {
  type: typeof DELETE_XTP_XDP_CONNECTION
  payload: AxiosPromise<ServerResponse<XtpXdpConnection>>
}

export interface DeleteXtpXdpConnectionPendingAction extends AnyAction {
  type: typeof DELETE_XTP_XDP_CONNECTION_PENDING
  payload: AxiosResponse<ServerResponse<XtpXdpConnection>>
}
export interface DeleteXtpXdpConnectionFulfilledAction extends AnyAction {
  type: typeof DELETE_XTP_XDP_CONNECTION_FULFILLED
  payload: AxiosResponse<ServerResponse<XtpXdpConnection>>
}

export interface DeleteXtpXdpConnectionRejectedAction extends AnyAction {
  type: typeof DELETE_XTP_XDP_CONNECTION_REJECTED
  payload: AxiosResponse<ServerResponse<XtpXdpConnection>>
}

export interface UpdateErrors extends AnyAction {
  type: typeof UPDATE_XTP_XDP_CONNECTION_ERRORS
  payload: { connection: string, protocols: string[] }
}

export interface GetXtpXdpConnectionProtocolsAction extends AnyAction {
  type: typeof GET_XTP_XDP_CONNECTION_PROTOCOL
  payload: AxiosPromise<ServerResponse<XtpXdpConnectionProtocol>>
}

export interface GetXtpXdpConnectionProtocolsPendingAction extends AnyAction {
  type: typeof GET_XTP_XDP_CONNECTION_PROTOCOL_PENDING
  payload: AxiosResponse<ServerResponse<XtpXdpConnectionProtocol>>
}
export interface GetXtpXdpConnectionProtocolsFulfilledAction extends AnyAction {
  type: typeof GET_XTP_XDP_CONNECTION_PROTOCOL_FULFILLED
  payload: AxiosResponse<ServerResponse<XtpXdpConnectionProtocol>>
}

export interface GetXtpXdpConnectionProtocolsRejectedAction extends AnyAction {
  type: typeof GET_XTP_XDP_CONNECTION_PROTOCOL_REJECTED
  payload: AxiosResponse<ServerResponse<XtpXdpConnectionProtocol>>
}

export interface UpdateXtpXdpConnectionThunkProtocolAction extends ThunkAction<void, RootState, void, AnyAction> {}

export interface UpdateXtpOptionsAction extends AnyAction {
  type: typeof UPDATE_XTP_XDP_CONNECTION_PROTOCOL
  payload: AxiosPromise<ServerResponse<XtpXdpConnectionProtocol>>
}

export interface UpdateXtpOptionsPendingAction extends AnyAction {
  type: typeof UPDATE_XTP_XDP_CONNECTION_PROTOCOL_PENDING
  payload: AxiosResponse<ServerResponse<XtpXdpConnectionProtocol>>
}
export interface UpdateXtpOptionsFulfilledAction extends AnyAction {
  type: typeof UPDATE_XTP_XDP_CONNECTION_PROTOCOL_FULFILLED
  payload: AxiosResponse<ServerResponse<XtpXdpConnectionProtocol>>
}

export interface UpdateXtpOptionsRejectedAction extends AnyAction {
  type: typeof UPDATE_XTP_XDP_CONNECTION_PROTOCOL_REJECTED
  payload: AxiosResponse<ServerResponse<XtpXdpConnectionProtocol>>
}

export interface SelectXtpXdpConnection extends AnyAction {
  type: typeof SELECT_XTP_XDP_CONNECTION
  payload: XtpXdpConnectionProtocol[]
}

export type XtpActionTypes =
  GetXtpXdpConnectionAction |
  GetXtpXdpConnectionPendingAction |
  GetXtpXdpConnectionFulfilledAction |
  GetXtpXdpConnectionRejectedAction |
  GetXtpXdpConnectionByIdAction |
  GetXtpXdpConnectionByIdPendingAction |
  GetXtpXdpConnectionByIdFulfilledAction |
  GetXtpXdpConnectionByIdRejectedAction |
  CreateXtpXdpConnectionAction |
  CreateXtpXdpConnectionPendingAction |
  CreateXtpXdpConnectionFulfilledAction |
  CreateXtpXdpConnectionRejectedAction |
  UpdateXtpXdpConnectionAction |
  UpdateXtpXdpConnectionPendingAction |
  UpdateXtpXdpConnectionFulfilledAction |
  UpdateXtpXdpConnectionRejectedAction |
  DeleteXtpXdpConnectionAction |
  DeleteXtpXdpConnectionPendingAction |
  DeleteXtpXdpConnectionFulfilledAction |
  DeleteXtpXdpConnectionRejectedAction |
  UpdateErrors |
  GetXtpXdpConnectionProtocolsAction |
  GetXtpXdpConnectionProtocolsPendingAction |
  GetXtpXdpConnectionProtocolsFulfilledAction |
  GetXtpXdpConnectionProtocolsRejectedAction |
  UpdateXtpOptionsAction |
  UpdateXtpOptionsPendingAction |
  UpdateXtpOptionsFulfilledAction |
  UpdateXtpOptionsRejectedAction |
  SelectXtpXdpConnection;
